import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DxDataGridModule, DxFormModule, DxTextBoxModule } from 'devextreme-angular';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { ReasonService } from 'src/app/services/reason.service';
import { Reason, ReasonType } from 'src/app/interfaces/entities/reason';
import notify from 'devextreme/ui/notify';
import { AppGlobals } from 'src/app/app.globals';

@Component({
    selector: 'app-section-schedule-change',
    templateUrl: './section-schedule-change.component.html',
    styleUrls: ['./section-schedule-change.component.css'],
    imports: [CommonModule, GpdButtonComponent, DxFormModule, DxTextBoxModule, DxDataGridModule, SvgIconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionScheduleChangeComponent implements OnInit {
  editData: {
    id: number | null;
    name: string;
  } | null = null;

  reasons: Reason[] = [];
  reasonType = ReasonType.ScheduleChange;

  constructor(private reasonService: ReasonService, private cdr: ChangeDetectorRef) {}

  async ngOnInit() {
    await this.loadReasons();
  }

  async loadReasons() {
    try {
      const result = await this.reasonService.getReasons({
        type: this.reasonType,
      });

      if (!result.hasError) {
        this.reasons = result.reasons;
      } else {
        AppGlobals.ShowErrorMessage(result.feedback);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage('Failed to load reasons');
    }
    this.cdr.markForCheck();
  }

  onAdd() {
    this.editData = {
      id: null,
      name: '',
    };
  }

  onEdit(item: Reason) {
    this.editData = {
      id: item.id,
      name: item.name,
    };
  }

  onCancel() {
    this.editData = null;
  }

  async onSave() {

    try {
      const result = await this.reasonService.writeReason({
        reason: {
          id: this.editData.id,
          name: this.editData.name,
          type: this.reasonType,
          isDeleted: false,
        },
      });

      if (!result.hasError) {
        this.editData = null;
        await this.loadReasons();
      } else {
        AppGlobals.ShowErrorMessage(result.feedback);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage('Failed to save reason');
    }
    this.cdr.markForCheck();
  }

  async deleteReason(item: Reason) {

    try {
      const result = await this.reasonService.writeReason({
        reason: {
          id: item.id,
          name: item.name,
          type: item.type,
          isDeleted: true,
        },
      });

      if (!result.hasError) {
        await this.loadReasons();
      } else {
        AppGlobals.ShowErrorMessage(result.feedback);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage('Failed to delete reason');
    }
  }
}
